import { ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, Component, EventEmitter, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Validators, FormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { ModalService, ModalModule } from '@mt-ng2/modal-module';
import { MtAlertsModule } from '@mt-ng2/alerts-module';
import { DynamicField, DynamicFieldType, DynamicFieldTypes, LabelPosition, LabelPositions, DynamicFormModule } from '@mt-ng2/dynamic-form';
import { BackButtonService, CloseButtonStrategy, BackButtonModule } from '@mt-ng2/back-button-module';
import { PageTitlesModule } from '@mt-ng2/page-titles';
import { of, Subscription, throwError, EMPTY } from 'rxjs';
import { map, concatMap, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ClaimValues, ClaimsService, AuthModuleConfigToken, AuthGuard } from '@mt-ng2/auth-module';
import { common } from '@mt-ng2/common-functions';
import { NotificationsService } from '@mt-ng2/notifications-module';

/**
 * Recursively checks the route and it's parents for a data object with the claimTypeId and
 * returns the first claimTypeId found
 * @param routeSnapshot the route to check
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@mt-ng2/auth-module';
import * as ɵngcc2 from '@angular/common/http';
import * as ɵngcc3 from '@mt-ng2/modal-module';
import * as ɵngcc4 from '@mt-ng2/back-button-module';
import * as ɵngcc5 from '@angular/router';
import * as ɵngcc6 from '@angular/common';
import * as ɵngcc7 from '@mt-ng2/notifications-module';
import * as ɵngcc8 from '@mt-ng2/dynamic-form';
import * as ɵngcc9 from '@mt-ng2/page-titles';
import * as ɵngcc10 from '@mt-ng2/alerts-module';

function PermissionsFormComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵlistener("click", function PermissionsFormComponent_div_4_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const control_r3 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.handleParentClick(control_r3); });
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelement(2, "i", 7);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const control_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", control_r3.selected ? "fa-check-circle" : "fa-circle-thin");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(control_r3.permission.name);
} }
function PermissionsFormComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "button", 9);
    ɵngcc0.ɵɵlistener("click", function PermissionsFormComponent_div_9_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.selectAllChildrenClick(); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("\n                ", ctx_r1.allChildrenPermissionsSelected ? "Uncheck" : "Check", " All\n            ");
} }
function PermissionsFormComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵlistener("click", function PermissionsFormComponent_div_11_Template_div_click_0_listener() { const control_r8 = ctx.$implicit; return control_r8.selected = !control_r8.selected; });
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelement(2, "i", 7);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const control_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", control_r8.selected ? "fa-check-square" : "fa-square-o");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(control_r8.permission.name);
} }
function AccessSettingsComponent_div_5_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("Please correct the following emails: ", ctx_r1.errorEmails, "");
} }
function AccessSettingsComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n        ");
    ɵngcc0.ɵɵelementStart(2, "span", 2);
    ɵngcc0.ɵɵtext(3, "More then one email can be entered separated by a comma.");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n        ");
    ɵngcc0.ɵɵelementStart(5, "dynamic-field", 3);
    ɵngcc0.ɵɵlistener("valueChanges", function AccessSettingsComponent_div_5_Template_dynamic_field_valueChanges_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.overrideEmail = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n        ");
    ɵngcc0.ɵɵtemplate(7, AccessSettingsComponent_div_5_span_7_Template, 2, 1, "span", 4);
    ɵngcc0.ɵɵtext(8, "\n    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("field", ctx_r0.emailOverrideControl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorEmails);
} }
function MissingPermissionsButtonComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("click", function MissingPermissionsButtonComponent_div_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.openModal(); });
    ɵngcc0.ɵɵtext(1, "\n    ");
    ɵngcc0.ɵɵelementStart(2, "span", 2);
    ɵngcc0.ɵɵtext(3, "\n        ");
    ɵngcc0.ɵɵelement(4, "i", 3);
    ɵngcc0.ɵɵtext(5, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n    ");
    ɵngcc0.ɵɵelementStart(7, "no-access-modal", 4);
    ɵngcc0.ɵɵlistener("ready", function MissingPermissionsButtonComponent_div_0_Template_no_access_modal_ready_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.noAccessModalComponentApi = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(8, "\n");
    ɵngcc0.ɵɵelementEnd();
} }
const _c0 = function () { return ["/users"]; };
const _c1 = function (a0) { return { roleId: a0 }; };
const _c2 = function (a1) { return ["/roles", a1]; };
function EvaluateAccessRequestComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵtext(1, "\n    ");
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3, "\n        ");
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵtext(5, "\n            ");
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵtext(7, "\n                ");
    ɵngcc0.ɵɵelementStart(8, "div");
    ɵngcc0.ɵɵtext(9, "\n                    ");
    ɵngcc0.ɵɵelementStart(10, "h4");
    ɵngcc0.ɵɵtext(11, "Access Request Info");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(12, "\n                    ");
    ɵngcc0.ɵɵelementStart(13, "div", 0);
    ɵngcc0.ɵɵtext(14, "\n                        ");
    ɵngcc0.ɵɵelementStart(15, "div", 7);
    ɵngcc0.ɵɵtext(16, "\n                            ");
    ɵngcc0.ɵɵelementStart(17, "div", 8);
    ɵngcc0.ɵɵelementStart(18, "label");
    ɵngcc0.ɵɵtext(19, "Requested By:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(21, "\n                            ");
    ɵngcc0.ɵɵelementStart(22, "div", 8);
    ɵngcc0.ɵɵelementStart(23, "label");
    ɵngcc0.ɵɵtext(24, "Request Date:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(25);
    ɵngcc0.ɵɵpipe(26, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(27, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(28, "\n                        ");
    ɵngcc0.ɵɵelementStart(29, "div", 7);
    ɵngcc0.ɵɵtext(30, "\n                            ");
    ɵngcc0.ɵɵelementStart(31, "div", 8);
    ɵngcc0.ɵɵelementStart(32, "label");
    ɵngcc0.ɵɵtext(33, "Role:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(35, "\n                            ");
    ɵngcc0.ɵɵelementStart(36, "div", 9);
    ɵngcc0.ɵɵtext(37, "\n                                ");
    ɵngcc0.ɵɵelementStart(38, "a", 10);
    ɵngcc0.ɵɵtext(39, "users with this role ");
    ɵngcc0.ɵɵelement(40, "i", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(41, "br");
    ɵngcc0.ɵɵtext(42, "\n                                ");
    ɵngcc0.ɵɵelementStart(43, "a", 12);
    ɵngcc0.ɵɵtext(44, "current permissions for this role ");
    ɵngcc0.ɵɵelement(45, "i", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(46, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(47, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(48, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(49, "\n                    ");
    ɵngcc0.ɵɵelementStart(50, "div", 13);
    ɵngcc0.ɵɵtext(51, "\n                        ");
    ɵngcc0.ɵɵelementStart(52, "div", 8);
    ɵngcc0.ɵɵelementStart(53, "label");
    ɵngcc0.ɵɵtext(54, "Requested Permissions:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(55, "\n                        ");
    ɵngcc0.ɵɵelementStart(56, "permissions-form", 14);
    ɵngcc0.ɵɵlistener("ready", function EvaluateAccessRequestComponent_div_11_Template_permissions_form_ready_56_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.permissionsFormComponentApi = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(57, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(58, "\n                    ");
    ɵngcc0.ɵɵelementStart(59, "div", 15);
    ɵngcc0.ɵɵtext(60, "\n                        ");
    ɵngcc0.ɵɵelementStart(61, "div", 0);
    ɵngcc0.ɵɵtext(62, "\n                            ");
    ɵngcc0.ɵɵelementStart(63, "div", 7);
    ɵngcc0.ɵɵtext(64, "\n                                ");
    ɵngcc0.ɵɵelementStart(65, "div", 16);
    ɵngcc0.ɵɵtext(66, "\n                                    ");
    ɵngcc0.ɵɵelementStart(67, "h3");
    ɵngcc0.ɵɵtext(68, "Approve");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(69, "\n                                    ");
    ɵngcc0.ɵɵelementStart(70, "div", 17);
    ɵngcc0.ɵɵtext(71, "\n                                        ");
    ɵngcc0.ɵɵelementStart(72, "div", 18);
    ɵngcc0.ɵɵtext(73, "\n                                            ");
    ɵngcc0.ɵɵelementStart(74, "p");
    ɵngcc0.ɵɵtext(75, "\n                                                Add the selected permissions to the role ");
    ɵngcc0.ɵɵelementStart(76, "strong");
    ɵngcc0.ɵɵtext(77);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(78, "\n                                            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(79, "\n                                            ");
    ɵngcc0.ɵɵelementStart(80, "button", 19);
    ɵngcc0.ɵɵlistener("mtConfirm", function EvaluateAccessRequestComponent_div_11_Template_button_mtConfirm_80_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.approveForUserRole(); });
    ɵngcc0.ɵɵtext(81, "\n                                                Add to Role\n                                            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(82, "\n                                        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(83, "\n                                        ");
    ɵngcc0.ɵɵelementStart(84, "div", 18);
    ɵngcc0.ɵɵtext(85, "\n                                            ");
    ɵngcc0.ɵɵelementStart(86, "p");
    ɵngcc0.ɵɵtext(87, "\n                                                Create a new role for ");
    ɵngcc0.ɵɵelementStart(88, "strong");
    ɵngcc0.ɵɵtext(89);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(90, "\n                                            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(91, "\n                                            ");
    ɵngcc0.ɵɵelementStart(92, "button", 19);
    ɵngcc0.ɵɵlistener("mtConfirm", function EvaluateAccessRequestComponent_div_11_Template_button_mtConfirm_92_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.approveForNewUserRole(); });
    ɵngcc0.ɵɵtext(93, "\n                                                New Role\n                                            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(94, "\n                                        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(95, "\n                                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(96, "\n                                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(97, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(98, "\n                            ");
    ɵngcc0.ɵɵelementStart(99, "div", 7);
    ɵngcc0.ɵɵtext(100, "\n                                ");
    ɵngcc0.ɵɵelementStart(101, "div", 20);
    ɵngcc0.ɵɵtext(102, "\n                                    ");
    ɵngcc0.ɵɵelementStart(103, "h3");
    ɵngcc0.ɵɵtext(104, "Deny");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(105, "\n                                    ");
    ɵngcc0.ɵɵelementStart(106, "dynamic-field", 21);
    ɵngcc0.ɵɵlistener("valueChanges", function EvaluateAccessRequestComponent_div_11_Template_dynamic_field_valueChanges_106_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.denialMessage = $event; })("keydown.enter", function EvaluateAccessRequestComponent_div_11_Template_dynamic_field_keydown_enter_106_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.denyWithMessage(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(107, "\n                                    ");
    ɵngcc0.ɵɵelementStart(108, "button", 22);
    ɵngcc0.ɵɵlistener("mtConfirm", function EvaluateAccessRequestComponent_div_11_Template_button_mtConfirm_108_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.denyWithMessage(); });
    ɵngcc0.ɵɵtext(109, "\n                                        Deny\n                                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(110, "\n                                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(111, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(112, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(113, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(114, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(115, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(116, "\n        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(117, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(118, "\n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(20);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.accessRequest.RequesterName, "");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(26, 13, ctx_r0.accessRequest.RequestDate), "");
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.accessRequest.RequesterRoleName, "");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction0(15, _c0))("queryParams", ɵngcc0.ɵɵpureFunction1(16, _c1, ctx_r0.accessRequest.RequesterRoleId));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(18, _c2, ctx_r0.accessRequest.RequesterRoleId));
    ɵngcc0.ɵɵadvance(13);
    ɵngcc0.ɵɵproperty("permissions", ctx_r0.accessRequest.Permissions);
    ɵngcc0.ɵɵadvance(21);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.accessRequest.RequesterRoleName);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("mtConfirmOptions", ctx_r0.buttonConfirmOptions);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.accessRequest.RequesterName);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("mtConfirmOptions", ctx_r0.buttonConfirmOptions);
    ɵngcc0.ɵɵadvance(14);
    ɵngcc0.ɵɵproperty("field", ctx_r0.denialMessageControl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("mtConfirmOptions", ctx_r0.buttonConfirmOptions);
} }
function getClaimTypeIdFromRoute(routeSnapshot) {
    // if we have data and a claimType, then return it
    if (routeSnapshot.data && routeSnapshot.data.claimType) {
        return routeSnapshot.data.claimType;
    }
    // if no data, but we do have a parent, check that for the claimType
    if (routeSnapshot.parent) {
        return this.getClaimTypeIdFromRoute(routeSnapshot.parent);
    }
    // if all else fails return null
    return null;
}
function buildPermissionName(claimType, parentClaimType, claimValueId) {
    let name = '';
    if (parentClaimType) {
        name += `${parentClaimType.Name}: `;
    }
    name += claimType.Name;
    if (!parentClaimType) {
        name += ` (${claimValueId === ClaimValues.ReadOnly ? 'read only' : 'can edit'})`;
    }
    return name;
}
function mapPermissionsToClaims(permissions) {
    return permissions.map((permission) => ({ ClaimTypeId: permission.claimTypeId, ClaimValueId: permission.claimValueId }));
}

class PermissionsService {
    constructor(claimsService, http) {
        this.claimsService = claimsService;
        this.http = http;
    }
    /**
     * Builds out an array of permissions based on the passed in route. This is done using
     * the IRoleGuard in the route's data object.
     * @param route
     * @param returnOnlyMissingPermissions (default true) only returns permissions that the currently logged in user is missing
     */
    getPermissionsFromActivatedRoute(route, returnOnlyMissingPermissions = true) {
        const claimTypeId = getClaimTypeIdFromRoute(route);
        if (!claimTypeId) {
            return of([]);
        }
        return this.getPermissionsByClaimTypeId(claimTypeId, { returnOnlyMissingPermissions: returnOnlyMissingPermissions });
    }
    /**
     * Builds out an array of permissions based on a parent claim type id
     * @param claimTypeId parent claim type id
     * * * *
     * rest of the params are in an "options" object in the second parameter position
     * @param claimValue (default null) if present, limits the parent permission to one claim value (either read only or can edit)
     * @param returnOnlyMissingPermissions (default true) only returns permissions that the currently logged in user is missing
     */
    getPermissionsByClaimTypeId(claimTypeId, options) {
        options = Object.assign({ returnOnlyMissingPermissions: true }, options);
        return this.http
            .get('/access-requests/claims')
            .pipe(map((claimTypes) => this.buildPermissionsFromClaimTypeId(claimTypeId, options.claimValue, claimTypes, options.returnOnlyMissingPermissions)));
    }
    /**
     * Builds out an array of permissions based on provided array of claims
     * @param claims
     * * * *
     * rest of the params are in an "options" object in the second parameter position
     * @param returnOnlyMissingPermissions (default true) only returns permissions that the currently logged in user is missing
     */
    getPermissionsFromClaims(claims, options = { returnOnlyMissingPermissions: true }) {
        return this.http
            .get('/access-requests/claims')
            .pipe(map((claimTypes) => this.buildPermissionsFromClaims(claims, claimTypes, options.returnOnlyMissingPermissions)));
    }
    buildPermissionsFromClaimTypeId(claimTypeId, claimValue, claimTypes, returnOnlyMissingPermissions) {
        const claims = [];
        const parentClaimType = claimTypes.find((ct) => ct.Id === claimTypeId);
        if (!parentClaimType) {
            throw new RangeError(`Failed to find claimType with id: ${claimTypeId}`);
        }
        const childClaimTypes = claimTypes.filter((ct) => ct.ParentId === parentClaimType.Id);
        // add the parent claim(s)
        if (claimValue) {
            claims.push({ ClaimTypeId: parentClaimType.Id, ClaimValueId: claimValue });
        }
        else {
            claims.push({ ClaimTypeId: parentClaimType.Id, ClaimValueId: ClaimValues.ReadOnly });
            claims.push({ ClaimTypeId: parentClaimType.Id, ClaimValueId: ClaimValues.FullAccess });
        }
        // add the child claims
        childClaimTypes.forEach((cct) => claims.push({ ClaimTypeId: cct.Id, ClaimValueId: ClaimValues.FullAccess }));
        // build out the permissions
        return this.buildPermissionsFromClaims(claims, claimTypes, returnOnlyMissingPermissions);
    }
    buildPermissionsFromClaims(claims, claimTypes, returnOnlyMissingPermissions) {
        let permissions = [];
        claims.forEach((claim) => {
            const claimType = claimTypes.find((ct) => ct.Id === claim.ClaimTypeId);
            const parentClaimType = claimTypes.find((ct) => ct.Id === claimType.ParentId);
            permissions.push({
                claimTypeId: claim.ClaimTypeId,
                claimValueId: claim.ClaimValueId,
                name: buildPermissionName(claimType, parentClaimType, claim.ClaimValueId),
                parentId: claimType.ParentId,
            });
        });
        const parentPermissions = permissions.filter((p) => !p.parentId);
        common.sortByProperty(parentPermissions, 'name');
        const childPermissions = permissions.filter((p) => p.parentId);
        common.sortByProperty(childPermissions, 'name');
        permissions = parentPermissions.concat(childPermissions);
        if (returnOnlyMissingPermissions) {
            return permissions.filter(this.isCurrentUserMissingPermission.bind(this));
        }
        else {
            return permissions;
        }
    }
    isCurrentUserMissingPermission(permission) {
        const claimValuesToCheck = permission.claimValueId === ClaimValues.ReadOnly ? [ClaimValues.ReadOnly, ClaimValues.FullAccess] : [ClaimValues.FullAccess];
        return !this.claimsService.hasClaim(permission.claimTypeId, claimValuesToCheck);
    }
}
PermissionsService.ɵfac = function PermissionsService_Factory(t) { return new (t || PermissionsService)(ɵngcc0.ɵɵinject(ɵngcc1.ClaimsService), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient)); };
PermissionsService.ɵprov = ɵɵdefineInjectable({ factory: function PermissionsService_Factory() { return new PermissionsService(ɵɵinject(ClaimsService), ɵɵinject(HttpClient)); }, token: PermissionsService, providedIn: "root" });
PermissionsService.ctorParameters = () => [
    { type: ClaimsService },
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PermissionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.ClaimsService }, { type: ɵngcc2.HttpClient }]; }, null); })();

class AccessRequestsService {
    constructor(http, permissionsService) {
        this.http = http;
        this.permissionsService = permissionsService;
    }
    create(permissions) {
        return this.http.post('/access-requests', mapPermissionsToClaims(permissions));
    }
    /**
     * Gets the access request for evaluation, building out the Permissions from the RequestedClaims.
     *
     * If the request has already been handled or if the token
     * is wrong, the request will return null.
     * @param token
     */
    getByToken(token) {
        return (this.http
            .get(`/access-requests/by-token/${token}`)
            // after getting the request from the BE, use the permissions service to build out the Permissions property
            .pipe(concatMap((accessRequest) => {
            // If I don't get a request it is probably already processed so I'm returning null.
            if (!accessRequest) {
                return of(null);
            }
            const requestedClaims = accessRequest.AccessRequestClaims.map((arc) => ({
                ClaimTypeId: arc.ClaimTypeId,
                ClaimValueId: arc.ClaimValueId,
            }));
            return this.permissionsService.getPermissionsFromClaims(requestedClaims, { returnOnlyMissingPermissions: false }).pipe(map((permissions) => {
                accessRequest.Permissions = permissions;
                return accessRequest;
            }));
        })));
    }
    /**
     * Approve the request.  If passed newRoleName, then create a new role with these permissions else
     * add these permissions to existing role for the user.
     * @param token
     * @param permissions - approved permissions
     * @param newRoleName - (optional) if has a value, will cause the BE to create a new user role
     */
    approve(token, permissions, newRoleName) {
        const data = {
            ApprovedClaims: mapPermissionsToClaims(permissions),
            NewRoleName: newRoleName,
        };
        return this.http.post(`/access-requests/by-token/${token}/approve`, data);
    }
    deny(token, denialInfo) {
        return this.http.post(`/access-requests/by-token/${token}/deny`, denialInfo);
    }
}
AccessRequestsService.ɵfac = function AccessRequestsService_Factory(t) { return new (t || AccessRequestsService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(PermissionsService)); };
AccessRequestsService.ɵprov = ɵɵdefineInjectable({ factory: function AccessRequestsService_Factory() { return new AccessRequestsService(ɵɵinject(HttpClient), ɵɵinject(PermissionsService)); }, token: AccessRequestsService, providedIn: "root" });
AccessRequestsService.ctorParameters = () => [
    { type: HttpClient },
    { type: PermissionsService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccessRequestsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: PermissionsService }]; }, null); })();

class AccessRequestsUxHelperService {
    constructor(modalService, backButtonService, router, authConfig) {
        this.modalService = modalService;
        this.backButtonService = backButtonService;
        this.router = router;
        this.authConfig = authConfig;
    }
    requestSubmittedMessageModal() {
        return this.modalService.showModal({
            text: 'Your request has been submitted.  When a decision is made, you will be notified through email.',
            type: 'success',
        });
    }
    navigateBackOrHome() {
        var _a, _b;
        const previousLink = this.backButtonService.previousNavigationRouterLink.getValue();
        if (previousLink === null || previousLink === void 0 ? void 0 : previousLink.url) {
            this.router.navigateByUrl(previousLink.url);
        }
        else {
            this.router.navigateByUrl(((_b = (_a = this.authConfig) === null || _a === void 0 ? void 0 : _a.pathOverrides) === null || _b === void 0 ? void 0 : _b.homePath) || '/home');
        }
    }
}
AccessRequestsUxHelperService.ɵfac = function AccessRequestsUxHelperService_Factory(t) { return new (t || AccessRequestsUxHelperService)(ɵngcc0.ɵɵinject(ɵngcc3.ModalService), ɵngcc0.ɵɵinject(ɵngcc4.BackButtonService), ɵngcc0.ɵɵinject(ɵngcc5.Router), ɵngcc0.ɵɵinject(AuthModuleConfigToken)); };
AccessRequestsUxHelperService.ɵprov = ɵɵdefineInjectable({ factory: function AccessRequestsUxHelperService_Factory() { return new AccessRequestsUxHelperService(ɵɵinject(ModalService), ɵɵinject(BackButtonService), ɵɵinject(Router), ɵɵinject(AuthModuleConfigToken)); }, token: AccessRequestsUxHelperService, providedIn: "root" });
AccessRequestsUxHelperService.ctorParameters = () => [
    { type: ModalService },
    { type: BackButtonService },
    { type: Router },
    { type: undefined, decorators: [{ type: Inject, args: [AuthModuleConfigToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccessRequestsUxHelperService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.ModalService }, { type: ɵngcc4.BackButtonService }, { type: ɵngcc5.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: [AuthModuleConfigToken]
            }] }]; }, null); })();

/**
 * Will be shown anytime the user goes to a route that they do not have the claims to view.
 * Uses the claimTypeId that was set in the AccessRequestsModuleConfigService to determine
 * the list of permissions that the user may want to request access to and displays them
 * using the PermissionsFormComponent.  Provides a button to request any permissions selected.
 */
class NoAccessComponent {
    constructor(permissionsService, accessRequestsService, route, modalService, accessRequestsUxHelperService) {
        this.permissionsService = permissionsService;
        this.accessRequestsService = accessRequestsService;
        this.route = route;
        this.modalService = modalService;
        this.accessRequestsUxHelperService = accessRequestsUxHelperService;
        this.closeButtonStrategy = CloseButtonStrategy.History;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.route.params.subscribe(() => {
            this.buildPermissionsByClaimTypeId();
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    buildPermissionsByClaimTypeId() {
        this.claimTypeId = +this.route.snapshot.paramMap.get('claimTypeId');
        this.permissionsService
            .getPermissionsByClaimTypeId(this.claimTypeId)
            .pipe(catchError((error) => {
            if (!(error instanceof RangeError)) {
                // for any error other than RangeError rethrow
                return throwError(error);
            }
            else {
                // if we get a rangeError it is most likely from the Url Param for claimTypeId
                // being set to an invalid value, so just send return empty array
                return of([]);
            }
        }))
            .subscribe((permissions) => {
            if (!(permissions && permissions.length)) {
                // if we have no permissions, then send the user to home page
                this.accessRequestsUxHelperService.navigateBackOrHome();
            }
            else if (this.permissionsFormComponentApi) {
                // if we already have the permissionsForm api then use it
                // since this handles resetting the form on new navigation
                this.permissionsFormComponentApi.setPermissions(permissions);
            }
            else {
                // else use the property which binds to the permissions form
                this.permissions = permissions;
            }
        });
    }
    requestPermissions() {
        this.accessRequestsService.create(this.permissionsFormComponentApi.getSelectedPermissions()).subscribe((success) => {
            this.accessRequestsUxHelperService
                .requestSubmittedMessageModal()
                .subscribe(() => this.accessRequestsUxHelperService.navigateBackOrHome());
        });
    }
}
NoAccessComponent.ɵfac = function NoAccessComponent_Factory(t) { return new (t || NoAccessComponent)(ɵngcc0.ɵɵdirectiveInject(PermissionsService), ɵngcc0.ɵɵdirectiveInject(AccessRequestsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ModalService), ɵngcc0.ɵɵdirectiveInject(AccessRequestsUxHelperService)); };
NoAccessComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NoAccessComponent, selectors: [["ng-component"]], decls: 33, vars: 2, consts: [[1, "no-access-wrapper"], [1, "no-access-body"], [1, "text-center"], ["alt", "No Access Door to Brick Wall", "src", "assets/no-access-access-request.png", 2, "max-height", "400px"], [1, "h4"], [1, "permissions"], [3, "permissions", "ready"], [1, "btn", "btn-primary", 3, "click"], ["buttonInnerHtml", "Back", 3, "strategy"]], template: function NoAccessComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtext(3, "\n        ");
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtext(5, "\n            ");
        ɵngcc0.ɵɵelementStart(6, "h3");
        ɵngcc0.ɵɵtext(7, "No Access");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n            ");
        ɵngcc0.ɵɵelement(9, "img", 3);
        ɵngcc0.ɵɵtext(10, "\n            ");
        ɵngcc0.ɵɵelementStart(11, "h4", 4);
        ɵngcc0.ɵɵtext(12, "Looks like you don't have permission to access this page");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(13, "\n            ");
        ɵngcc0.ɵɵelementStart(14, "h4");
        ɵngcc0.ɵɵtext(15, "No worries, you can request access below");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(16, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(17, "\n        ");
        ɵngcc0.ɵɵelementStart(18, "div", 5);
        ɵngcc0.ɵɵtext(19, "\n            ");
        ɵngcc0.ɵɵelementStart(20, "permissions-form", 6);
        ɵngcc0.ɵɵlistener("ready", function NoAccessComponent_Template_permissions_form_ready_20_listener($event) { return ctx.permissionsFormComponentApi = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(21, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(22, "\n        ");
        ɵngcc0.ɵɵelementStart(23, "div", 2);
        ɵngcc0.ɵɵtext(24, "\n            ");
        ɵngcc0.ɵɵelementStart(25, "button", 7);
        ɵngcc0.ɵɵlistener("click", function NoAccessComponent_Template_button_click_25_listener() { return ctx.requestPermissions(); });
        ɵngcc0.ɵɵtext(26, "Request Permissions");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(27, "\n            ");
        ɵngcc0.ɵɵelement(28, "close-button", 8);
        ɵngcc0.ɵɵtext(29, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(30, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(31, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(32, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(20);
        ɵngcc0.ɵɵproperty("permissions", ctx.permissions);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("strategy", ctx.closeButtonStrategy);
    } }, directives: function () { return [PermissionsFormComponent, ɵngcc4.CloseButtonComponent]; }, styles: [".no-access-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:center;margin-top:40px;position:relative}.permissions[_ngcontent-%COMP%]{margin-bottom:20px;margin-top:40px}@media only screen and (max-width:600px){.no-access-wrapper[_ngcontent-%COMP%]{display:initial}}@media only screen and (max-width:600px){img[_ngcontent-%COMP%]{width:100%}}"] });
NoAccessComponent.ctorParameters = () => [
    { type: PermissionsService },
    { type: AccessRequestsService },
    { type: ActivatedRoute },
    { type: ModalService },
    { type: AccessRequestsUxHelperService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NoAccessComponent, [{
        type: Component,
        args: [{
                template: "<div class=\"no-access-wrapper\">\n    <div class=\"no-access-body\">\n        <div class=\"text-center\">\n            <h3>No Access</h3>\n            <img style=\"max-height: 400px\" alt=\"No Access Door to Brick Wall\" src=\"assets/no-access-access-request.png\" />\n            <h4 class=\"h4\">Looks like you don't have permission to access this page</h4>\n            <h4>No worries, you can request access below</h4>\n        </div>\n        <div class=\"permissions\">\n            <permissions-form [permissions]=\"permissions\" (ready)=\"permissionsFormComponentApi = $event\"></permissions-form>\n        </div>\n        <div class=\"text-center\">\n            <button class=\"btn btn-primary\" (click)=\"requestPermissions()\">Request Permissions</button>\n            <close-button [strategy]=\"closeButtonStrategy\" buttonInnerHtml=\"Back\"></close-button>\n        </div>\n    </div>\n</div>\n",
                styles: [".no-access-wrapper{display:flex;justify-content:center;margin-top:40px;position:relative}.permissions{margin-bottom:20px;margin-top:40px}@media only screen and (max-width:600px){.no-access-wrapper{display:initial}}@media only screen and (max-width:600px){img{width:100%}}"]
            }]
    }], function () { return [{ type: PermissionsService }, { type: AccessRequestsService }, { type: ɵngcc5.ActivatedRoute }, { type: ɵngcc3.ModalService }, { type: AccessRequestsUxHelperService }]; }, null); })();

/**
 * Designed to take in a list of permissions and display them as a series of
 * radio buttons and check boxes.  Separates parents from children and displays
 * them differently while allowing only one parent item (i.e. readonly or full
 * access) to be chosen, with any number of child items.
 *
 * Provides methods via it's api.
 * ```html
 * <permissions-form (ready)="permissionsFormComponentApi = $event"></permissions-form>
 * ```
 */
class PermissionsFormComponent {
    constructor() {
        this.ready = new EventEmitter();
    }
    get allChildrenPermissionsSelected() {
        return this.childPermissionsForm && this.childPermissionsForm.some((permission) => !permission.selected) ? false : true;
    }
    ngOnInit() {
        if (this.permissions) {
            this.buildForm(this.permissions);
        }
        this.ready.emit({
            getSelectedPermissions: this.getSelectedPermissions.bind(this),
            setPermissions: this.setPermissions.bind(this),
        });
    }
    buildForm(permissions) {
        // build out parent permissions, marking the first one automatically selected
        this.parentPermissionsForm = permissions
            .filter((permission) => !permission.parentId)
            .map((permission, index) => ({ permission: permission, selected: index ? false : true }));
        // build out the child permissions
        this.childPermissionsForm = permissions
            .filter((permission) => permission.parentId)
            .map((permission) => ({ permission: permission, selected: false }));
    }
    setPermissions(permissions) {
        this.permissions = permissions;
        this.buildForm(permissions);
    }
    /**
     * takes in the control that was clicked and ensures that one and only that one is selected, since
     * parent level permissions are exclusive of each other (can only be readonly or can edit, not both)
     */
    handleParentClick(control) {
        if (control.selected) {
            return;
        }
        this.parentPermissionsForm.forEach((permissions) => (permissions.selected = false));
        control.selected = true;
    }
    // used in the api
    getSelectedPermissions() {
        if (!this.parentPermissionsForm) {
            return [];
        }
        const allPermissions = this.parentPermissionsForm.concat(this.childPermissionsForm);
        return allPermissions.filter((value) => value.selected).map((value) => value.permission);
    }
    selectAllChildrenClick() {
        if (this.allChildrenPermissionsSelected) {
            this.childPermissionsForm.forEach((permission) => (permission.selected = false));
        }
        else {
            this.childPermissionsForm.forEach((permission) => (permission.selected = true));
        }
    }
}
PermissionsFormComponent.ɵfac = function PermissionsFormComponent_Factory(t) { return new (t || PermissionsFormComponent)(); };
PermissionsFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PermissionsFormComponent, selectors: [["permissions-form"]], inputs: { permissions: "permissions" }, outputs: { ready: "ready" }, decls: 15, vars: 3, consts: [[1, "permissions-wrapper"], [1, "parent-permissions"], ["class", "permission", 3, "click", 4, "ngFor", "ngForOf"], [1, "child-permissions", "list-group"], ["class", "select-all-button", 4, "ngIf"], ["class", "permission list-group-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "permission", 3, "click"], [1, "fa", "fa-fw", "fa-lg", 3, "ngClass"], [1, "select-all-button"], [1, "btn", "btn-xs", "btn-primary", "pull-right", 3, "click"], [1, "permission", "list-group-item", 3, "click"]], template: function PermissionsFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtext(3, "\n        ");
        ɵngcc0.ɵɵtemplate(4, PermissionsFormComponent_div_4_Template, 7, 2, "div", 2);
        ɵngcc0.ɵɵtext(5, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(6, "\n    ");
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵtext(8, "\n        ");
        ɵngcc0.ɵɵtemplate(9, PermissionsFormComponent_div_9_Template, 5, 1, "div", 4);
        ɵngcc0.ɵɵtext(10, "\n        ");
        ɵngcc0.ɵɵtemplate(11, PermissionsFormComponent_div_11_Template, 7, 2, "div", 5);
        ɵngcc0.ɵɵtext(12, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(13, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(14, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.parentPermissionsForm);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.childPermissionsForm && ctx.childPermissionsForm.length > 1);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.childPermissionsForm);
    } }, directives: [ɵngcc6.NgForOf, ɵngcc6.NgIf, ɵngcc6.NgClass], styles: [".permissions-wrapper[_ngcontent-%COMP%]{text-align:left}.parent-permissions[_ngcontent-%COMP%]{font-size:1.4em}.parent-permissions[_ngcontent-%COMP%]   .permission[_ngcontent-%COMP%], .parent-permissions[_ngcontent-%COMP%]   .permission[_ngcontent-%COMP%] > label[_ngcontent-%COMP%]{cursor:pointer}.child-permissions[_ngcontent-%COMP%]{font-size:1em;margin-left:40px;margin-top:10px}.child-permissions[_ngcontent-%COMP%]   .permission[_ngcontent-%COMP%], .child-permissions[_ngcontent-%COMP%]   .permission[_ngcontent-%COMP%] > label[_ngcontent-%COMP%]{cursor:pointer}.select-all-button[_ngcontent-%COMP%]{height:26px}"] });
PermissionsFormComponent.propDecorators = {
    permissions: [{ type: Input }],
    ready: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PermissionsFormComponent, [{
        type: Component,
        args: [{
                selector: 'permissions-form',
                template: "<div class=\"permissions-wrapper\">\n    <div class=\"parent-permissions\">\n        <div *ngFor=\"let control of parentPermissionsForm\" (click)=\"handleParentClick(control)\" class=\"permission\">\n            <i class=\"fa fa-fw fa-lg\" [ngClass]=\"control.selected ? 'fa-check-circle' : 'fa-circle-thin'\"></i>\n            <label>{{ control.permission.name }}</label>\n        </div>\n    </div>\n    <div class=\"child-permissions list-group\">\n        <div *ngIf=\"childPermissionsForm && childPermissionsForm.length > 1\" class=\"select-all-button\">\n            <button class=\"btn btn-xs btn-primary pull-right\" (click)=\"selectAllChildrenClick()\">\n                {{ allChildrenPermissionsSelected ? 'Uncheck' : 'Check' }} All\n            </button>\n        </div>\n        <div *ngFor=\"let control of childPermissionsForm\" (click)=\"control.selected = !control.selected\" class=\"permission list-group-item\">\n            <i class=\"fa fa-fw fa-lg\" [ngClass]=\"control.selected ? 'fa-check-square' : 'fa-square-o'\"></i>\n            <label>{{ control.permission.name }}</label>\n        </div>\n    </div>\n</div>\n",
                styles: [".permissions-wrapper{text-align:left}.parent-permissions{font-size:1.4em}.parent-permissions .permission,.parent-permissions .permission>label{cursor:pointer}.child-permissions{font-size:1em;margin-left:40px;margin-top:10px}.child-permissions .permission,.child-permissions .permission>label{cursor:pointer}.select-all-button{height:26px}"]
            }]
    }], function () { return []; }, { ready: [{
            type: Output
        }], permissions: [{
            type: Input
        }] }); })();

/**
 * This modal displays the passed in permissions and allows for the user to
 * request access to any of them. Provides an api to show this modal.
 * ```html
 * <!-- in your template -->
 * <no-access-modal (ready)="modalApi = $event"></no-access-modal>
 * ```
 * ```typescript
 * // in your ts file
 * public modalApi: INoAccessModalComponentApi;
 *
 * showNoAccessModal(permissions: IPermission[]): void {
 *     this.modalApi.show(permissions);
 * }
 * ```
 */
class NoAccessModalComponent {
    constructor(accessRequestsService, notificationsService, accessRequestsUxHelperService) {
        this.accessRequestsService = accessRequestsService;
        this.notificationsService = notificationsService;
        this.accessRequestsUxHelperService = accessRequestsUxHelperService;
        this.ready = new EventEmitter();
        this.modalOptions = {
            width: '600px',
        };
    }
    ngOnInit() {
        this.ready.emit({ show: this.show.bind(this) });
    }
    show(permissions) {
        this.permissionsFormComponentApi.setPermissions(permissions);
        this.modalWrapperApi.show();
    }
    closeClick() {
        this.modalWrapperApi.close();
    }
    requestPermissions() {
        const requestedPermissions = this.permissionsFormComponentApi.getSelectedPermissions();
        if (requestedPermissions.length) {
            this.accessRequestsService.create(requestedPermissions).subscribe(() => {
                this.accessRequestsUxHelperService.requestSubmittedMessageModal().subscribe(() => this.modalWrapperApi.close());
            });
        }
        else {
            this.notificationsService.error('At least one permission must be selected.');
        }
    }
}
NoAccessModalComponent.ɵfac = function NoAccessModalComponent_Factory(t) { return new (t || NoAccessModalComponent)(ɵngcc0.ɵɵdirectiveInject(AccessRequestsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.NotificationsService), ɵngcc0.ɵɵdirectiveInject(AccessRequestsUxHelperService)); };
NoAccessModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NoAccessModalComponent, selectors: [["no-access-modal"]], outputs: { ready: "ready" }, decls: 34, vars: 3, consts: [[3, "autoShow", "showActions", "options", "ready"], [1, "no-access-wrapper"], [1, "no-access-body"], [1, "text-center"], ["alt", "No Access Door to Brick Wall", "src", "assets/no-access-access-request.png", 2, "max-height", "400px", "width", "100%"], [1, "permissions"], [3, "ready"], [1, "btn", "btn-primary", 3, "click"], [1, "btn", "btn-default", 3, "click"]], template: function NoAccessModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "modal-wrapper", 0);
        ɵngcc0.ɵɵlistener("ready", function NoAccessModalComponent_Template_modal_wrapper_ready_0_listener($event) { return ctx.modalWrapperApi = $event; });
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtext(3, "\n        ");
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtext(5, "\n            ");
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵtext(7, "\n                ");
        ɵngcc0.ɵɵelement(8, "img", 4);
        ɵngcc0.ɵɵtext(9, "\n                ");
        ɵngcc0.ɵɵelementStart(10, "h4");
        ɵngcc0.ɵɵtext(11, "Looks like you are missing some permissions for this page");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(12, "\n                ");
        ɵngcc0.ɵɵelementStart(13, "h4");
        ɵngcc0.ɵɵtext(14, "No worries, you can request access below");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(15, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(16, "\n            ");
        ɵngcc0.ɵɵelementStart(17, "div", 5);
        ɵngcc0.ɵɵtext(18, "\n                ");
        ɵngcc0.ɵɵelementStart(19, "permissions-form", 6);
        ɵngcc0.ɵɵlistener("ready", function NoAccessModalComponent_Template_permissions_form_ready_19_listener($event) { return ctx.permissionsFormComponentApi = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(20, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(21, "\n            ");
        ɵngcc0.ɵɵelementStart(22, "div", 3);
        ɵngcc0.ɵɵtext(23, "\n                ");
        ɵngcc0.ɵɵelementStart(24, "button", 7);
        ɵngcc0.ɵɵlistener("click", function NoAccessModalComponent_Template_button_click_24_listener() { return ctx.requestPermissions(); });
        ɵngcc0.ɵɵtext(25, "Request Permissions");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(26, "\n                ");
        ɵngcc0.ɵɵelementStart(27, "button", 8);
        ɵngcc0.ɵɵlistener("click", function NoAccessModalComponent_Template_button_click_27_listener() { return ctx.closeClick(); });
        ɵngcc0.ɵɵtext(28, "Close");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(29, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(30, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(31, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(32, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(33, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("autoShow", false)("showActions", false)("options", ctx.modalOptions);
    } }, directives: [ɵngcc3.ɵa, PermissionsFormComponent], styles: [".no-access-wrapper[_ngcontent-%COMP%]{justify-content:center;margin-top:40px;position:relative}.permissions[_ngcontent-%COMP%]{font-size:14px;margin-bottom:20px;margin-top:40px}"] });
NoAccessModalComponent.ctorParameters = () => [
    { type: AccessRequestsService },
    { type: NotificationsService },
    { type: AccessRequestsUxHelperService }
];
NoAccessModalComponent.propDecorators = {
    ready: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NoAccessModalComponent, [{
        type: Component,
        args: [{
                selector: 'no-access-modal',
                template: "<modal-wrapper [autoShow]=\"false\" [showActions]=\"false\" [options]=\"modalOptions\" (ready)=\"modalWrapperApi = $event\">\n    <div class=\"no-access-wrapper\">\n        <div class=\"no-access-body\">\n            <div class=\"text-center\">\n                <img style=\"max-height: 400px; width: 100%\" alt=\"No Access Door to Brick Wall\" src=\"assets/no-access-access-request.png\" />\n                <h4>Looks like you are missing some permissions for this page</h4>\n                <h4>No worries, you can request access below</h4>\n            </div>\n            <div class=\"permissions\">\n                <permissions-form (ready)=\"permissionsFormComponentApi = $event\"></permissions-form>\n            </div>\n            <div class=\"text-center\">\n                <button class=\"btn btn-primary\" (click)=\"requestPermissions()\">Request Permissions</button>\n                <button class=\"btn btn-default\" (click)=\"closeClick()\">Close</button>\n            </div>\n        </div>\n    </div>\n</modal-wrapper>\n",
                styles: [".no-access-wrapper{justify-content:center;margin-top:40px;position:relative}.permissions{font-size:14px;margin-bottom:20px;margin-top:40px}"]
            }]
    }], function () { return [{ type: AccessRequestsService }, { type: ɵngcc7.NotificationsService }, { type: AccessRequestsUxHelperService }]; }, { ready: [{
            type: Output
        }] }); })();

var SettingsDataTypes;
(function (SettingsDataTypes) {
    SettingsDataTypes[SettingsDataTypes["OverrideEmailRequests"] = 1] = "OverrideEmailRequests";
})(SettingsDataTypes || (SettingsDataTypes = {}));
class AccessSettings {
    static areEmailsValid(commaSeparatedEmails) {
        if (commaSeparatedEmails === '' || commaSeparatedEmails === null) {
            return [];
        }
        const emails = commaSeparatedEmails.replace(/\s/g, '').split(',');
        const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let invalidEmails = emails.filter((email) => email === '' || !regex.test(email));
        return invalidEmails;
    }
}

class AccessSettingsService {
    constructor(http) {
        this.http = http;
    }
    saveAccessSettings(overrideEmail) {
        const requestBody = { EmailNotificationOverride: overrideEmail };
        return this.http.post(`/access-request-settings`, requestBody);
    }
    getEmailOverrideSetting() {
        return this.http.get(`/access-request-settings/${SettingsDataTypes.OverrideEmailRequests}`);
    }
}
AccessSettingsService.ɵfac = function AccessSettingsService_Factory(t) { return new (t || AccessSettingsService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient)); };
AccessSettingsService.ɵprov = ɵɵdefineInjectable({ factory: function AccessSettingsService_Factory() { return new AccessSettingsService(ɵɵinject(HttpClient)); }, token: AccessSettingsService, providedIn: "root" });
AccessSettingsService.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccessSettingsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }]; }, null); })();

/**
 * Component that can be implemented in your Breck app that controls Access Requests settings.
 * Will allow the user to enter one or more email addresses to override the default destination for
 * access request emails. If nothing is entered the system will send the emails to anyone with
 * the user permission of Access Requests on their role.
 */
class AccessSettingsComponent {
    constructor(accessSettingsService, notificationsService) {
        this.accessSettingsService = accessSettingsService;
        this.notificationsService = notificationsService;
        this.formReady = false;
        this.doubleClickIsDisabled = false;
        this.typeDisabled = false;
        this.emailOverrideControl = new DynamicField({
            formGroup: '',
            label: 'Override Email',
            name: 'Override Email',
            placeholder: 'test@email.com,test2@email.com',
            type: new DynamicFieldType({
                fieldType: DynamicFieldTypes.Input,
            }),
            validation: [Validators.maxLength(250)],
            validators: { maxlength: 250 },
            value: '',
        });
        this.ready = new EventEmitter();
    }
    ngOnInit() {
        this.populateSettingsData();
        this.ready.emit({
            saveSettings: this.saveSettings.bind(this),
        });
    }
    populateSettingsData() {
        this.accessSettingsService.getEmailOverrideSetting().subscribe((setting) => {
            this.emailOverrideControl.value = setting.EmailNotificationOverride;
            this.overrideEmail = setting.EmailNotificationOverride;
            this.formReady = true;
        });
    }
    saveSettings() {
        const validateEmails = AccessSettings.areEmailsValid(this.overrideEmail);
        if (validateEmails.length > 0) {
            this.notificationsService.error('One or more emails not in a valid format.');
            this.errorEmails = validateEmails.join(' - ');
            return EMPTY;
        }
        return this.accessSettingsService.saveAccessSettings(this.overrideEmail);
    }
}
AccessSettingsComponent.ɵfac = function AccessSettingsComponent_Factory(t) { return new (t || AccessSettingsComponent)(ɵngcc0.ɵɵdirectiveInject(AccessSettingsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.NotificationsService)); };
AccessSettingsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AccessSettingsComponent, selectors: [["access-settings"]], outputs: { ready: "ready" }, decls: 8, vars: 1, consts: [[1, "access-settings-wrapper", "miles-form", "padded"], [4, "ngIf"], [1, "text-muted"], [3, "field", "valueChanges"], ["class", "small errortext", 4, "ngIf"], [1, "small", "errortext"]], template: function AccessSettingsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "h4");
        ɵngcc0.ɵɵtext(3, "Access Settings");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(4, "\n    ");
        ɵngcc0.ɵɵtemplate(5, AccessSettingsComponent_div_5_Template, 9, 2, "div", 1);
        ɵngcc0.ɵɵtext(6, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formReady);
    } }, directives: [ɵngcc6.NgIf, ɵngcc8.DynamicFieldComponent], styles: [".access-settings-wrapper[_ngcontent-%COMP%]{margin-top:40px;position:relative}"] });
AccessSettingsComponent.ctorParameters = () => [
    { type: AccessSettingsService },
    { type: NotificationsService }
];
AccessSettingsComponent.propDecorators = {
    ready: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccessSettingsComponent, [{
        type: Component,
        args: [{
                selector: 'access-settings',
                template: "<div class=\"access-settings-wrapper miles-form padded\">\n    <h4>Access Settings</h4>\n    <div *ngIf=\"formReady\">\n        <span class=\"text-muted\">More then one email can be entered separated by a comma.</span>\n        <dynamic-field [field]=\"emailOverrideControl\" (valueChanges)=\"overrideEmail = $event\"></dynamic-field>\n        <span *ngIf=\"errorEmails\" class=\"small errortext\">Please correct the following emails: {{ errorEmails }}</span>\n    </div>\n</div>\n",
                styles: [".access-settings-wrapper{margin-top:40px;position:relative}"]
            }]
    }], function () { return [{ type: AccessSettingsService }, { type: ɵngcc7.NotificationsService }]; }, { ready: [{
            type: Output
        }] }); })();

/**
 * This component is designed to display as a button with a lock icon, that if clicked
 * will show a dialog for requesting access to missing permissions. It can either be
 * passed in claims to build the permissions from, or it can automatically derive them
 * based on the RouteGuard. The button will only show if it determines that the user
 * is missing at least one of the permissions.
 */
class MissingPermissionsButtonComponent {
    constructor(permissionsService, route) {
        this.permissionsService = permissionsService;
        this.route = route;
        this.missingPermissions = [];
    }
    ngOnInit() {
        if (this.claims) {
            this.permissionsService.getPermissionsFromClaims(this.claims).subscribe((value) => (this.missingPermissions = value));
        }
        else {
            this.permissionsService.getPermissionsFromActivatedRoute(this.route.snapshot).subscribe((value) => (this.missingPermissions = value));
        }
    }
    openModal() {
        this.noAccessModalComponentApi.show(this.missingPermissions);
    }
}
MissingPermissionsButtonComponent.ɵfac = function MissingPermissionsButtonComponent_Factory(t) { return new (t || MissingPermissionsButtonComponent)(ɵngcc0.ɵɵdirectiveInject(PermissionsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.ActivatedRoute)); };
MissingPermissionsButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MissingPermissionsButtonComponent, selectors: [["missing-permissions-button"]], inputs: { claims: "claims" }, decls: 2, vars: 1, consts: [["class", "missing-permissions-button-wrapper", "data-toggle", "tooltip", "data-html", "true", "data-placement", "right", "title", "Click here to request permissions", 3, "click", 4, "ngIf"], ["data-toggle", "tooltip", "data-html", "true", "data-placement", "right", "title", "Click here to request permissions", 1, "missing-permissions-button-wrapper", 3, "click"], [1, "btn", "btn-transparent", "missing-permissions-button"], [1, "fa", "fa-lock"], [3, "ready"]], template: function MissingPermissionsButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MissingPermissionsButtonComponent_div_0_Template, 9, 0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.missingPermissions.length);
    } }, directives: [ɵngcc6.NgIf, NoAccessModalComponent], styles: [".missing-permissions-button-wrapper[_ngcontent-%COMP%]{display:inline-block}.missing-permissions-button-wrapper[_ngcontent-%COMP%]   .missing-permissions-button[_ngcontent-%COMP%]{border-radius:3px;font-size:1em;padding:.1em .5em;transition:box-shadow .2s}.missing-permissions-button-wrapper[_ngcontent-%COMP%]   .missing-permissions-button[_ngcontent-%COMP%]:hover{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2)}"] });
MissingPermissionsButtonComponent.ctorParameters = () => [
    { type: PermissionsService },
    { type: ActivatedRoute }
];
MissingPermissionsButtonComponent.propDecorators = {
    claims: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MissingPermissionsButtonComponent, [{
        type: Component,
        args: [{
                selector: 'missing-permissions-button',
                template: "<div\n    *ngIf=\"missingPermissions.length\"\n    class=\"missing-permissions-button-wrapper\"\n    data-toggle=\"tooltip\"\n    data-html=\"true\"\n    data-placement=\"right\"\n    title=\"Click here to request permissions\"\n    (click)=\"openModal()\"\n>\n    <span class=\"btn btn-transparent missing-permissions-button\">\n        <i class=\"fa fa-lock\"></i>\n    </span>\n    <no-access-modal (ready)=\"noAccessModalComponentApi = $event\"></no-access-modal>\n</div>\n",
                styles: [".missing-permissions-button-wrapper{display:inline-block}.missing-permissions-button-wrapper .missing-permissions-button{border-radius:3px;font-size:1em;padding:.1em .5em;transition:box-shadow .2s}.missing-permissions-button-wrapper .missing-permissions-button:hover{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2)}"]
            }]
    }], function () { return [{ type: PermissionsService }, { type: ɵngcc5.ActivatedRoute }]; }, { claims: [{
            type: Input
        }] }); })();

class EvaluateAccessRequestComponent {
    constructor(route, accessRequestsService, notificationsService, accessRequestsUxHelperService) {
        this.route = route;
        this.accessRequestsService = accessRequestsService;
        this.notificationsService = notificationsService;
        this.accessRequestsUxHelperService = accessRequestsUxHelperService;
        this.buttonConfirmOptions = {
            confirmButtonText: 'Yes',
            text: '',
        };
        this.denialMessageControl = new DynamicField({
            formGroup: '',
            label: 'Denial Message',
            labelPosition: new LabelPosition({ position: LabelPositions.Hidden }),
            name: 'DenialMessage',
            placeholder: '(optional) message to send with your denial',
            type: new DynamicFieldType({
                fieldType: DynamicFieldTypes.Input,
            }),
            validation: [Validators.maxLength(2000)],
            validators: { maxlength: 2000 },
            value: '',
        });
    }
    get newRoleName() {
        if (this.accessRequest.RequesterRoleName.includes(`for ${this.accessRequest.RequesterName}`)) {
            return `${this.accessRequest.RequesterRoleName}`;
        }
        return `${this.accessRequest.RequesterRoleName} for ${this.accessRequest.RequesterName}`;
    }
    ngOnInit() {
        const accessRequestToken = this.route.snapshot.paramMap.get('accessRequestToken');
        this.accessRequestsService
            .getByToken(accessRequestToken)
            .pipe(catchError((error) => {
            if (error && error.status === 401) {
                this.notificationsService.error('You do not have access to evaluate access requests');
                this.accessRequestsUxHelperService.navigateBackOrHome();
            }
            return of(error);
        }))
            .subscribe((accessRequestOrError) => {
            if (accessRequestOrError && accessRequestOrError.status === 401) {
                // do nothing, already rerouting based on error
            }
            else if (!accessRequestOrError) {
                this.notificationsService.info('That access request has already been decided');
                this.accessRequestsUxHelperService.navigateBackOrHome();
            }
            else {
                this.accessRequest = accessRequestOrError;
            }
        });
    }
    approveForUserRole() {
        this.approve();
    }
    approveForNewUserRole() {
        this.approve(this.newRoleName);
    }
    approve(newRoleName) {
        const selectedPermissions = this.permissionsFormComponentApi.getSelectedPermissions();
        if (selectedPermissions.length) {
            this.accessRequestsService.approve(this.accessRequest.RequestToken, selectedPermissions, newRoleName).subscribe(() => {
                this.routeAwayWithSuccessNotification();
            });
        }
        else {
            this.notificationsService.error('At least one permission must be selected.');
        }
    }
    denyWithMessage() {
        this.accessRequestsService.deny(this.accessRequest.RequestToken, { DenialReason: this.denialMessage }).subscribe(() => {
            this.routeAwayWithSuccessNotification();
        });
    }
    routeAwayWithSuccessNotification() {
        this.notificationsService.success('Request updated successfully');
        this.accessRequestsUxHelperService.navigateBackOrHome();
    }
}
EvaluateAccessRequestComponent.ɵfac = function EvaluateAccessRequestComponent_Factory(t) { return new (t || EvaluateAccessRequestComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(AccessRequestsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.NotificationsService), ɵngcc0.ɵɵdirectiveInject(AccessRequestsUxHelperService)); };
EvaluateAccessRequestComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EvaluateAccessRequestComponent, selectors: [["ng-component"]], decls: 13, vars: 1, consts: [[1, "row"], [1, "col-md-7"], ["pageTitle", "Evaluate Access Request"], ["class", "row", 4, "ngIf"], [1, "col-md-8"], [1, "evaluate-access-wrapper"], [1, "miles-form", "padded"], [1, "col-md-6"], [1, "display-padded"], [1, "role-links"], ["target", "_blank", 3, "routerLink", "queryParams"], [1, "fa", "fa-external-link"], ["target", "_blank", 3, "routerLink"], [1, "permissions"], [3, "permissions", "ready"], [1, "text-center", "actions"], [1, "actions-container", "approve"], [1, "approve-actions-container"], [1, "approve-action"], [1, "btn", "btn-primary", "btn-block", 3, "mtConfirmOptions", "mtConfirm"], [1, "actions-container", "deny"], [3, "field", "valueChanges", "keydown.enter"], [1, "btn", "btn-danger", "btn-block", 3, "mtConfirmOptions", "mtConfirm"]], template: function EvaluateAccessRequestComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtext(3, "\n        ");
        ɵngcc0.ɵɵelementStart(4, "h2");
        ɵngcc0.ɵɵtext(5, "\n            ");
        ɵngcc0.ɵɵelement(6, "mt-page-title", 2);
        ɵngcc0.ɵɵtext(7, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(9, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(10, "\n\n");
        ɵngcc0.ɵɵtemplate(11, EvaluateAccessRequestComponent_div_11_Template, 119, 20, "div", 3);
        ɵngcc0.ɵɵtext(12, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(11);
        ɵngcc0.ɵɵproperty("ngIf", ctx.accessRequest);
    } }, directives: [ɵngcc9.PageTitleComponent, ɵngcc6.NgIf, ɵngcc5.RouterLinkWithHref, PermissionsFormComponent, ɵngcc10.MtConfirmDirective, ɵngcc8.DynamicFieldComponent], pipes: [ɵngcc6.DatePipe], styles: [".actions[_ngcontent-%COMP%]{margin-top:20px}.actions-container[_ngcontent-%COMP%]{border:3px solid;border-radius:25px;min-height:154px;padding:10px 20px}.actions-container[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:1.5em;font-style:italic;margin:-10px -10px 10px}.approve[_ngcontent-%COMP%]{border-color:rgba(40,167,69,.35)}.approve[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{color:rgba(40,167,69,.35)}.approve[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{background-color:rgba(40,167,69,.8)}.deny[_ngcontent-%COMP%]{border-color:rgba(220,53,69,.35)}.deny[_ngcontent-%COMP%], .deny[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{color:rgba(220,53,69,.35)}.approve-actions-container[_ngcontent-%COMP%]{display:table;margin-left:-10px;margin-right:-10px}.approve-actions-container[_ngcontent-%COMP%]   .approve-action[_ngcontent-%COMP%]{display:table-cell;height:105px;padding-left:10px;padding-right:10px;vertical-align:bottom;width:50%}.role-links[_ngcontent-%COMP%]{font-size:.9em;line-height:1.4em;margin-left:15px;margin-top:-5px}"] });
EvaluateAccessRequestComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: AccessRequestsService },
    { type: NotificationsService },
    { type: AccessRequestsUxHelperService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EvaluateAccessRequestComponent, [{
        type: Component,
        args: [{
                template: "<div class=\"row\">\n    <div class=\"col-md-7\">\n        <h2>\n            <mt-page-title pageTitle=\"Evaluate Access Request\"></mt-page-title>\n        </h2>\n    </div>\n</div>\n\n<div *ngIf=\"accessRequest\" class=\"row\">\n    <div class=\"col-md-8\">\n        <div class=\"evaluate-access-wrapper\">\n            <div class=\"miles-form padded\">\n                <div>\n                    <h4>Access Request Info</h4>\n                    <div class=\"row\">\n                        <div class=\"col-md-6\">\n                            <div class=\"display-padded\"><label>Requested By:</label> {{ accessRequest.RequesterName }}</div>\n                            <div class=\"display-padded\"><label>Request Date:</label> {{ accessRequest.RequestDate | date }}</div>\n                        </div>\n                        <div class=\"col-md-6\">\n                            <div class=\"display-padded\"><label>Role:</label> {{ accessRequest.RequesterRoleName }}</div>\n                            <div class=\"role-links\">\n                                <a [routerLink]=\"['/users']\" [queryParams]=\"{ roleId: accessRequest.RequesterRoleId }\" target=\"_blank\"\n                                    >users with this role <i class=\"fa fa-external-link\"></i></a\n                                ><br />\n                                <a [routerLink]=\"['/roles', accessRequest.RequesterRoleId]\" target=\"_blank\"\n                                    >current permissions for this role <i class=\"fa fa-external-link\"></i\n                                ></a>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"permissions\">\n                        <div class=\"display-padded\"><label>Requested Permissions:</label></div>\n                        <permissions-form [permissions]=\"accessRequest.Permissions\" (ready)=\"permissionsFormComponentApi = $event\"></permissions-form>\n                    </div>\n                    <div class=\"text-center actions\">\n                        <div class=\"row\">\n                            <div class=\"col-md-6\">\n                                <div class=\"actions-container approve\">\n                                    <h3>Approve</h3>\n                                    <div class=\"approve-actions-container\">\n                                        <div class=\"approve-action\">\n                                            <p>\n                                                Add the selected permissions to the role <strong>{{ accessRequest.RequesterRoleName }}</strong>\n                                            </p>\n                                            <button\n                                                class=\"btn btn-primary btn-block\"\n                                                (mtConfirm)=\"approveForUserRole()\"\n                                                [mtConfirmOptions]=\"buttonConfirmOptions\"\n                                            >\n                                                Add to Role\n                                            </button>\n                                        </div>\n                                        <div class=\"approve-action\">\n                                            <p>\n                                                Create a new role for <strong>{{ accessRequest.RequesterName }}</strong>\n                                            </p>\n                                            <button\n                                                class=\"btn btn-primary btn-block\"\n                                                (mtConfirm)=\"approveForNewUserRole()\"\n                                                [mtConfirmOptions]=\"buttonConfirmOptions\"\n                                            >\n                                                New Role\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col-md-6\">\n                                <div class=\"actions-container deny\">\n                                    <h3>Deny</h3>\n                                    <dynamic-field\n                                        [field]=\"denialMessageControl\"\n                                        (valueChanges)=\"denialMessage = $event\"\n                                        (keydown.enter)=\"denyWithMessage()\"\n                                    ></dynamic-field>\n                                    <button\n                                        class=\"btn btn-danger btn-block\"\n                                        (mtConfirm)=\"denyWithMessage()\"\n                                        [mtConfirmOptions]=\"buttonConfirmOptions\"\n                                    >\n                                        Deny\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n",
                styles: [".actions{margin-top:20px}.actions-container{border:3px solid;border-radius:25px;min-height:154px;padding:10px 20px}.actions-container h3{font-size:1.5em;font-style:italic;margin:-10px -10px 10px}.approve{border-color:rgba(40,167,69,.35)}.approve h3{color:rgba(40,167,69,.35)}.approve .btn{background-color:rgba(40,167,69,.8)}.deny{border-color:rgba(220,53,69,.35)}.deny,.deny h3{color:rgba(220,53,69,.35)}.approve-actions-container{display:table;margin-left:-10px;margin-right:-10px}.approve-actions-container .approve-action{display:table-cell;height:105px;padding-left:10px;padding-right:10px;vertical-align:bottom;width:50%}.role-links{font-size:.9em;line-height:1.4em;margin-left:15px;margin-top:-5px}"]
            }]
    }], function () { return [{ type: ɵngcc5.ActivatedRoute }, { type: AccessRequestsService }, { type: ɵngcc7.NotificationsService }, { type: AccessRequestsUxHelperService }]; }, null); })();

class AccessRequestsModule {
}
AccessRequestsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AccessRequestsModule });
AccessRequestsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AccessRequestsModule_Factory(t) { return new (t || AccessRequestsModule)(); }, imports: [[CommonModule, RouterModule, ModalModule, MtAlertsModule, DynamicFormModule, BackButtonModule, FormsModule, PageTitlesModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AccessRequestsModule, { declarations: function () { return [NoAccessComponent, PermissionsFormComponent, NoAccessModalComponent, MissingPermissionsButtonComponent, EvaluateAccessRequestComponent, AccessSettingsComponent]; }, imports: function () { return [CommonModule, RouterModule, ModalModule, MtAlertsModule, DynamicFormModule, BackButtonModule, FormsModule, PageTitlesModule]; }, exports: function () { return [NoAccessComponent, NoAccessModalComponent, MissingPermissionsButtonComponent, EvaluateAccessRequestComponent, AccessSettingsComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccessRequestsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NoAccessComponent,
                    PermissionsFormComponent,
                    NoAccessModalComponent,
                    MissingPermissionsButtonComponent,
                    EvaluateAccessRequestComponent,
                    AccessSettingsComponent,
                ],
                exports: [NoAccessComponent, NoAccessModalComponent, MissingPermissionsButtonComponent, EvaluateAccessRequestComponent, AccessSettingsComponent],
                imports: [CommonModule, RouterModule, ModalModule, MtAlertsModule, DynamicFormModule, BackButtonModule, FormsModule, PageTitlesModule]
            }]
    }], null, null); })();

const routes = [
    {
        canActivate: [AuthGuard],
        component: NoAccessComponent,
        path: 'no-access-page/:claimTypeId',
    },
    {
        canActivate: [AuthGuard],
        component: EvaluateAccessRequestComponent,
        path: 'evaluate-access-request/:accessRequestToken',
    },
];
class AccessRequestsRoutingModule {
}
AccessRequestsRoutingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AccessRequestsRoutingModule });
AccessRequestsRoutingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AccessRequestsRoutingModule_Factory(t) { return new (t || AccessRequestsRoutingModule)(); }, imports: [[RouterModule.forChild(routes)], RouterModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AccessRequestsRoutingModule, { imports: function () { return [ɵngcc5.RouterModule]; }, exports: function () { return [RouterModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccessRequestsRoutingModule, [{
        type: NgModule,
        args: [{
                exports: [RouterModule],
                imports: [RouterModule.forChild(routes)]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AccessRequestsModule, AccessRequestsRoutingModule, NoAccessComponent as ɵa, PermissionsService as ɵb, AccessRequestsService as ɵc, AccessRequestsUxHelperService as ɵd, PermissionsFormComponent as ɵe, NoAccessModalComponent as ɵf, MissingPermissionsButtonComponent as ɵg, EvaluateAccessRequestComponent as ɵh, AccessSettingsComponent as ɵi, AccessSettingsService as ɵj };

//# sourceMappingURL=mt-ng2-access-requests-module.js.map